// global
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Dropdown } from 'semantic-ui-react';

class CustomDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
            props,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ searchQuery: '', props: nextProps });
    }

    handleSearch = (e, { searchQuery }) => this.setState({ searchQuery });

    render() {
        const { searchQuery, props } = this.state;
        const { isForm, ...rest } = props;
        const Component = isForm ? Form.Dropdown : Dropdown;
        return <Component {...rest} search searchQuery={searchQuery} onSearchChange={this.handleSearch} noResultsMessage="Termo não encontrado." />;
    }
}

CustomDropdown.defaultProps = {
    isForm: true,
};

CustomDropdown.propTypes = {
    isForm: PropTypes.bool,
};

export default CustomDropdown;
